// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Options } from '@contentful/rich-text-react-renderer'
import { BLOCKS } from '@contentful/rich-text-types'
import { Footer, ParagraphXL, TitleLG } from '@/atoms/Text'

export const giveawayRichTextOverrides = (options: Options) => {
  return {
    ...options,
    renderNode: {
      ...options.renderNode,
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <ParagraphXL color="giveaway-text-subtle-light" weight="normal" className="mb-10 last:mb-0">
          {children}
        </ParagraphXL>
      ),
      [BLOCKS.HEADING_2]: (node, children) => (
        <TitleLG color="giveaway-text-primary-dark" className="md:photon-heading-sm mb-3 font-semibold md:font-bold">
          {children}
        </TitleLG>
      ),
      [BLOCKS.UL_LIST]: (_, children) => <ul className="mb-10 flex list-disc flex-col gap-2 pl-6">{children}</ul>,
    },
  }
}

export const giveawayRulesRichTextOverrides = (options: Options) => {
  return {
    ...options,
    renderNode: {
      ...options.renderNode,
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Footer color="white" weight="normal" className="mb-2 block last:mb-0">
          {children}
        </Footer>
      ),
    },
  }
}
